/* EZ floating buttons (Ban-08, 2026-10-11) — loaded on every page from layout/theme.liquid.
   1. "My cart" button: every page except the cart page (checkout is Shopify's own page and never loads this
      file). Shown once the page is scrolled past the header, hidden while the cart is empty. The number comes from
      the header's cart bubble, which the theme keeps up to date. Phones and tablets since Ban-08; computers too
      since Ban-29.
      Look: in the spirit of Pawfect House (round button + small "MY CART" label), made our own: gift-bag icon,
      EZ teal ring, EZ orange count, soft shadow, a little pop when it appears and a bump when something is added.
   2. Klaviyo gift button (the floating "gift" teaser of the sign-up form): it joins the right-hand column with
      My cart and the back-to-top arrow (Ban-28 phones, Ban-29 computers): a 50px round button with My cart's teal
      ring and shadow, just above My cart (in My cart's place while that one is hidden). Klaviyo still decides on
      which pages it shows; only its place and frame change here. (Before Ban-28: bottom-left corner.) Hidden while
      the mobile menu, search or another drawer is open, and while a popup is open.
      Ban-29, phones: while both would show, My cart stands in for the two and opens to them (section 5).
   3. Footer end: no more large empty band under the copyright on phones; at the very end of the page the
      floating buttons (cart, Klaviyo gift) fade out so they do not sit on the footer's last lines. Space is added back only while a sticky
      bar (product "Preview & Add to Cart", cart "Checkout") is on screen, so the last lines are never covered.
   Styles live in this file; nothing else to install. */
/* 60. Ban-68 — buttons answer at once: Facebook Pixel's "automatic events" are off for the store's pixels.
       With them on, Facebook Pixel (3 pixels on this store) watched every click on the page and, for each click on a
       <button> (the gallery's small pictures, arrows, quantity, Add to cart…), recorded a "SubscribedButtonClick":
       53–70 ms of work inside the click and 3 hidden forms added to the page (measured on TEST 5 with real clicks,
       17/10: small pictures 80–112 ms → 24–48 ms to the next frame, long frames 68–141 ms → 0, forms 3 → 0).
       Same switch Pawfect House's pixel app uses ("autoConfig" false). PageView, ViewContent, AddToCart, Purchase and
       every event the pixel app sends are not touched; Facebook no longer gets SubscribedButtonClick and the page
       data it read by itself. The pixels may start before or after this file: checked for ~20 s after load. */
(function () {
  "use strict";
  var tries = 0;
  function stillOn(id) {
    try { var o = window.fbq.instance.optIns._opts.InferredEvents; return !o || o[id] !== false; } catch (e) { return true; }
  }
  function off() {
    var q = window.fbq, px;
    if (!q || typeof q.getState !== "function") return;
    try { px = q.getState().pixels || []; } catch (e) { return; }
    px.forEach(function (p) {
      var id = p && p.id;
      if (id && stillOn(String(id))) { try { q("set", "autoConfig", false, String(id)); } catch (e) {} }
    });
  }
  function tick() { off(); if (++tries < 30) setTimeout(tick, tries < 10 ? 300 : 1000); }
  tick();
  window.addEventListener("load", off);
})();

/* §62 (Ban-70) — a gift box (ez-offer.js, §61) is a line nested under its item. Shopify removes it with the item,
   but lowering the item's quantity in the cart leaves the boxes as they were: never more boxes than items.
   Only boxes added by §61 (hidden property _ezg) are touched; a box the customer lowers by hand stays as chosen. */
(function () {
  "use strict";
  function start() {
    // pubsub.js / constants.js (theme): subscribe is global, PUB_SUB_EVENTS is a top-level const (not on window)
    if (typeof subscribe !== "function" || typeof PUB_SUB_EVENTS === "undefined") return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) {
      if (!e || e.source !== "cart-items" || !e.cartData || !e.cartData.items) return;
      var items = e.cartData.items, byKey = {}, i, it, par;
      for (i = 0; i < items.length; i++) byKey[items[i].key] = items[i];
      for (i = 0; i < items.length; i++) {
        it = items[i];
        par = it.parent_relationship && byKey[it.parent_relationship.parent_key];
        if (par && it.properties && it.properties._ezg && it.quantity > par.quantity) {
          var host = document.querySelector("cart-drawer-items") || document.querySelector("cart-items");
          if (host && typeof host.updateQuantity === "function") {
            var line = i + 1, q = par.quantity;
            setTimeout(function () { host.updateQuantity(line, q); }, 0);
          }
          return; // one line at a time: the next update checks again
        }
      }
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();

(function () {
  "use strict";
  if (window.__ezFloating) return;
  window.__ezFloating = true;

  var path = (window.location.pathname || "/").replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/)/i, "");   /* /fr/cart -> /cart */
  var onCart = /^\/cart(\/|$)/.test(path);

  var CSS = [
    /* ---- 1. cart button (phones since Ban-08; Ban-29: computers too) ----
       Right-hand column, from the bottom up: back-to-top arrow, My cart, Klaviyo gift. All three are centred 37.5px
       from the right edge. Ban-29: computers show the same column (before: My cart was phone-only and the gift sat
       alone in the bottom-left corner). */
    ".ez-cartbtn{position:fixed;right:9px;bottom:calc(168px + env(safe-area-inset-bottom));z-index:999;display:flex;flex-direction:column;align-items:center;",
    "text-decoration:none!important;-webkit-tap-highlight-color:transparent;",
    "opacity:0;visibility:hidden;pointer-events:none;transform:translateY(10px) scale(.8);",
    "transition:opacity .2s ease,transform .32s cubic-bezier(.34,1.56,.64,1),visibility 0s linear .32s}",
    ".ez-cartbtn.is-on{opacity:1;visibility:visible;pointer-events:auto;transform:none;transition:opacity .2s ease,transform .32s cubic-bezier(.34,1.56,.64,1),visibility 0s}",
    /* Ban-122 (anh 21/10 18:58: My cart trên ĐT giật liên tục khi cuộn). Trước: nhảy lên 66 px mỗi lần thanh "Preview & Add
       to Cart" hiện / ẩn (body.ezp-sticky-on bật tắt nhiều lần khi cuộn qua form, kèm nảy lò xo: đo -72 → +6 px). Giờ trang SP
       trên ĐT: nút luôn ở chỗ cao (trên thanh dính) dù thanh đang hiện hay ẩn → đứng yên khi cuộn. */
    "@media (max-width:989px){body.product .ez-cartbtn.is-on,body.ezp-sticky-on .ez-cartbtn.is-on{transform:translateY(-66px)}}",
    ".ez-cartbtn__circle{position:relative;display:flex;align-items:center;justify-content:center;width:50px;height:50px;box-sizing:border-box;border-radius:50%;",
    "background:#fff;border:2px solid #02aeb8;color:#02aeb8;",
    "box-shadow:0 6px 16px -6px rgba(0, 0, 0,.22),0 2px 6px rgba(0, 0, 0,.08);transition:transform .15s ease,background-color .2s ease,border-color .2s ease,color .2s ease}",
    ".ez-cartbtn:active .ez-cartbtn__circle{transform:scale(.94)}",
    "@media (hover:hover) and (pointer:fine){.ez-cartbtn:hover .ez-cartbtn__circle{transform:translateY(-2px);box-shadow:0 10px 20px -8px rgba(0, 0, 0,.28),0 2px 6px rgba(0, 0, 0,.08)}}",
    ".ez-cartbtn__bag,.ez-cartbtn__x{display:flex;transition:opacity .18s ease,transform .28s cubic-bezier(.2,.9,.25,1)}",
    ".ez-cartbtn__circle svg{width:24px;height:24px;display:block;margin-top:-2px}",
    ".ez-cartbtn__x{position:absolute;opacity:0;transform:rotate(-90deg) scale(.6);color:#fff}",
    ".ez-cartbtn__x svg{width:20px;height:20px;margin:0}",
    ".ez-cartbtn__n{position:absolute;top:-6px;right:-7px;min-width:20px;height:20px;padding:0 5px;box-sizing:border-box;border-radius:10px;",
    "background:#f06724;color:#fff;font:700 11.5px/20px system-ui,-apple-system,'Segoe UI',Roboto,sans-serif;text-align:center;box-shadow:0 0 0 2px #fff;transition:opacity .15s ease,transform .2s ease}",
    ".ez-cartbtn__label{position:relative;z-index:1;margin-top:-9px;padding:3px 7px;border-radius:999px;background:#0299a2;color:#fff;",
    "font:800 8.5px/1 system-ui,-apple-system,'Segoe UI',Roboto,sans-serif;letter-spacing:.07em;text-transform:uppercase;white-space:nowrap;",
    "box-shadow:0 0 0 1.5px #fff,0 2px 6px rgba(7,8,29,.12);transition:opacity .15s ease}",
    ".ez-cartbtn.is-bump .ez-cartbtn__n{animation:ezCartBump .45s cubic-bezier(.34,1.56,.64,1)}",
    "@keyframes ezCartBump{0%{transform:scale(1)}35%{transform:scale(1.35)}100%{transform:scale(1)}}",
    "body.ezp-modal-open .ez-cartbtn,body.ezp-ai-open .ez-cartbtn,body.overflow-hidden-tablet .ez-cartbtn,body.overflow-hidden-mobile .ez-cartbtn,",
    "body.overflow-hidden .ez-cartbtn,body.ez-menu-open .ez-cartbtn{opacity:0!important;visibility:hidden!important;pointer-events:none!important}",

    /* ---- 2. Klaviyo gift teaser (Ban-28: right-hand column, same frame as My cart; Ban-29: computers too) ----
       Its circle lines up with My cart's (centre 37.5px from the right edge). Alone it sits where My cart's circle
       would be (174px up); when My cart shows (body.ez-cart-on) it moves up one step, 64px, so there is a 14px gap
       between the two. Over the product page's sticky bar (phones) both move up 66px together.
       Phones with both on screen: see section 5 (one button that opens to the two). */
    "div.needsclick[class*='kl-teaser-']{left:auto!important;right:12px!important;bottom:calc(174px + env(safe-area-inset-bottom))!important;top:auto!important;",
    "width:50px!important;height:50px!important;margin:0!important;filter:none!important;",
    "transform:none;transform-origin:50% 50%;transition:transform .32s cubic-bezier(.2,.8,.2,1),opacity .2s ease!important}",
    "div.needsclick[class*='kl-teaser-']>div{border-radius:50%;background:#fff;transition:transform .15s ease;",
    "box-shadow:0 0 0 2px #02aeb8,0 6px 16px -6px rgba(0, 0, 0,.22),0 2px 6px rgba(0, 0, 0,.08)}",
    "div.needsclick[class*='kl-teaser-'] span.needsclick{padding:3px!important}",
    "div.needsclick[class*='kl-teaser-']:active>div{transform:scale(.94)}",
    "@media (hover:hover) and (pointer:fine){div.needsclick[class*='kl-teaser-']:hover>div{transform:translateY(-2px)}}",
    "div.needsclick[class*='kl-teaser-'] button.klaviyo-close-form{top:-6px!important;left:-6px!important;right:auto!important}",
    "body.ez-cart-on div.needsclick[class*='kl-teaser-']{transform:translateY(-64px)}",
    "@media (max-width:989px){",
    "body.ezp-sticky-on div.needsclick[class*='kl-teaser-']{transform:translateY(-66px)}",
    "body.ezp-sticky-on.ez-cart-on div.needsclick[class*='kl-teaser-']{transform:translateY(-130px)}",
    "}",
    /* the theme's back-to-top arrow: same column (it sat 5px to the right of My cart) */
    "#top_scroll_button{right:20px!important}",
    /* Ban-84: "back to top" in neutral colours (its picture was an orange circle; orange is kept for buying), 40 px,
       hidden on product pages on phones/tablets (the sticky "Preview & Add to Cart" bar and My cart are there) */
    "#top_scroll_button{width:40px!important;height:40px!important;box-sizing:border-box;border:1px solid #e5e5e5;background:#fff!important;box-shadow:0 1px 4px rgba(29,29,31,.10)}",
    "#top_scroll_button i{display:none}",
    "#top_scroll_button::before{content:'';position:absolute;left:50%;top:56%;width:10px;height:10px;border-left:2px solid #1d1d1f;border-top:2px solid #1d1d1f;transform:translate(-50%,-50%) rotate(45deg)}",
    /* Ban-149 (anh 24/10): back on product pages, phones too (the header is no longer sticky there). It shows only
       past the product (global.js), between the sticky "Preview & Add to Cart" bar (75px) and My cart (lifted to
       234px on product pages): 96px from the bottom, same column, never moved by the bar. */
    "@media (max-width:989px){body.product #top_scroll_button{bottom:calc(96px + env(safe-area-inset-bottom))!important;transform:none!important}}",
    /* Ban-84: the cart count is orange (design system: orange = buying), was red #ff453a; a review badge with 0 reviews
       ("No reviews") is not shown (honesty rule: no "no reviews yet" text) */
    ".cart-count-bubble{background-color:#f06724!important;color:#fff!important}",
    "html body .jdgm-prev-badge.jdgm-prev-badge[data-number-of-reviews='0']{display:none!important}",   /* beats ez-*-directory.css (.ezrec … .jdgm-prev-badge inline-flex !important), which re-showed what Judge.me hides itself */
    "body.overflow-hidden-tablet div.needsclick[class*='kl-teaser-'],body.overflow-hidden-mobile div.needsclick[class*='kl-teaser-'],",
    "body.overflow-hidden div.needsclick[class*='kl-teaser-'],body.ezp-modal-open div.needsclick[class*='kl-teaser-'],",
    /* Ban-29: also under "Estimated delivery" and "Photo tips" (it sits above every backdrop otherwise; Ban-33: both
       use the same popup, html.ezp-ship-open) */
    "html.ezp-ship-open div.needsclick[class*='kl-teaser-'],",
    "body.ezp-ai-open div.needsclick[class*='kl-teaser-'],body.ez-menu-open div.needsclick[class*='kl-teaser-']{opacity:0!important;visibility:hidden!important;pointer-events:none!important}",

    /* ---- at the very end of the page: floating buttons step aside so the footer's last lines are clear ----
       (phones only; Ban-30: computers keep them on screen down to the footer, there is room beside it) */
    "@media (max-width:989px){body.ez-at-end .ez-cartbtn.is-on,body.ez-at-end div.needsclick[class*='kl-teaser-']{opacity:0!important;visibility:hidden!important;pointer-events:none!important}}",
    /* Ban-15: over the personalisation form (options, photo fields, Preview, Add to Cart) nothing floats on top of it.
       Ban-29: computers narrower than 1200px too (the form column reaches the right edge there); wider screens have
       room beside the form, and the back-to-top arrow stays as before on computers.
       Ban-121 (anh 21/10 16:52): My cart stays over the form once THIS product's personalised design is in the cart
       (body.ez-form-incart, set below from /cart.js), so the shopper can open the cart drawer from the form. */
    "@media (max-width:1199px){body.ez-in-form:not(.ez-form-incart) .ez-cartbtn.is-on,body.ez-in-form div.needsclick[class*='kl-teaser-']{opacity:0!important;visibility:hidden!important;pointer-events:none!important}}",
    "@media (max-width:989px){body.ez-in-form #top_scroll_button{opacity:0!important;visibility:hidden!important;pointer-events:none!important}}",
    /* Ban-32: the back-to-top arrow no longer sits on top of the open phone menu (it covered "Change") */
    "body.ez-menu-open #top_scroll_button{opacity:0!important;visibility:hidden!important;pointer-events:none!important}",

    /* ---- 5. My cart + gift in one button (Ban-29, phones) ----
       On every page where Klaviyo shows its gift AND the cart has something in it, one round button stands in for
       both, whatever the scroll position (Ban-30: before, it turned back into the gift near the top of the page,
       where My cart is not shown). With an empty cart there is nothing to combine: the plain gift button shows
       (Ban-31). Look (Ban-31, owner's pick "D"): My cart's own frame (white, teal ring, soft shadow, orange count)
       without the "MY CART" label, with an outlined sparkle that really twinkles: the big star softly lights up and
       turns, the small orange and teal stars flicker on their own rhythm (all still if the phone asks for reduced
       motion). A tap opens it: the page dims a little, the button turns teal with an X, and two choices rise above it with
       their names: "My cart (n)" and "Your gift" (Klaviyo's own gift button, so its form opens exactly as before).
       A tap outside, the X, Esc or a scroll closes it. It steps aside over the personalisation form like the other
       floating buttons. Pages where Klaviyo shows no gift keep the plain My cart button; computers keep the three
       separate buttons. */
    ".ez-cartbtn__hub,.ez-fab-dim,.ez-fab__item,.ez-fab__tag{display:none}",
    ".ez-cartbtn__n:empty{display:none}",
    "@media (max-width:989px){",
    "body{--ez-lift:0px}body.ezp-sticky-on{--ez-lift:-66px}",
    "body.ez-fab-on .ez-cartbtn__bag{display:none}",
    "body.ez-fab-on .ez-cartbtn__label{visibility:hidden}",
    "body.ez-fab-on .ez-cartbtn__hub{position:absolute;display:flex;transition:opacity .18s ease,transform .28s cubic-bezier(.2,.9,.25,1)}",
    ".ez-cartbtn__hub svg{width:26px;height:26px;margin:0;overflow:visible}",
    ".ez-cartbtn__hub .s1{fill:currentColor;fill-opacity:0;stroke:currentColor;stroke-width:1.7;stroke-linejoin:round;",
    "transform-box:fill-box;transform-origin:50% 50%;animation:ezHubGlow 3.2s ease-in-out infinite}",
    ".ez-cartbtn__hub .s2,.ez-cartbtn__hub .s3{transform-box:fill-box;transform-origin:50% 50%;animation:ezHubTwinkle 1.8s ease-in-out infinite}",
    ".ez-cartbtn__hub .s2{fill:#f06724}",
    ".ez-cartbtn__hub .s3{fill:currentColor;animation-duration:2.3s;animation-delay:.9s}",
    "@keyframes ezHubGlow{0%,100%{fill-opacity:0;transform:none}50%{fill-opacity:.22;transform:scale(1.07) rotate(4deg)}}",
    "@keyframes ezHubTwinkle{0%,100%{opacity:1;transform:none}40%{opacity:.2;transform:scale(.35) rotate(45deg)}60%{opacity:1;transform:scale(1.2) rotate(70deg)}80%{opacity:1;transform:scale(.95) rotate(90deg)}}",
    "body.ez-fab-open .ez-cartbtn__hub *{animation-play-state:paused}",
    "body.ez-fab-open .ez-cartbtn{z-index:1002}",
    "body.ez-fab-open .ez-cartbtn__circle{background:#0299a2;border-color:transparent}",
    "body.ez-fab-open .ez-cartbtn__hub{opacity:0;transform:rotate(90deg) scale(.6)}",
    "body.ez-fab-open .ez-cartbtn__x{opacity:1;transform:none}",
    "body.ez-fab-open .ez-cartbtn__n{opacity:0;transform:scale(.4)}",
    ".ez-fab-dim{position:fixed;inset:0;z-index:1000;display:block;background:rgba(17,24,39,.3);opacity:0;visibility:hidden;",
    "transition:opacity .22s ease,visibility 0s linear .22s;-webkit-tap-highlight-color:transparent}",
    "body.ez-fab-open .ez-fab-dim{opacity:1;visibility:visible;transition:opacity .22s ease,visibility 0s}",
    /* the two choices: 44px circles on the same centre line, 14px apart; names on white pills to their left */
    ".ez-fab__item{position:fixed;right:15.5px;bottom:calc(238px + env(safe-area-inset-bottom));z-index:1002;align-items:center;justify-content:center;width:44px;height:44px;box-sizing:border-box;",
    "border-radius:50%;background:#fff;border:2px solid #02aeb8;color:#02aeb8;text-decoration:none!important;box-shadow:0 6px 16px -6px rgba(0, 0, 0,.25),0 2px 6px rgba(0, 0, 0,.1);-webkit-tap-highlight-color:transparent}",
    ".ez-fab__item svg{width:21px;height:21px;display:block;margin-top:-1px}",
    ".ez-fab__tag{position:fixed;right:69.5px;z-index:1002;align-items:center;gap:4px;margin:0;padding:7px 12px;border:0;border-radius:999px;background:#fff;color:#1d1d1f;white-space:nowrap;cursor:pointer;",
    "font:600 13.5px/18px system-ui,-apple-system,'Segoe UI',Roboto,sans-serif;letter-spacing:0;text-decoration:none!important;box-shadow:0 4px 14px rgba(0, 0, 0,.16);-webkit-tap-highlight-color:transparent}",
    ".ez-fab__tag b{font-weight:700;color:#f06724}",
    ".ez-fab__tag--cart{bottom:calc(244px + env(safe-area-inset-bottom))}",
    ".ez-fab__tag--gift{bottom:calc(302px + env(safe-area-inset-bottom))}",
    "body.ez-fab-on .ez-fab__item,body.ez-fab-on .ez-fab__tag{display:flex}",
    ".ez-fab__item,.ez-fab__tag{opacity:0;visibility:hidden;pointer-events:none;transform:translateY(calc(var(--ez-lift) + 24px)) scale(.7);",
    "transition:opacity .16s ease,transform .2s ease,visibility 0s linear .2s}",
    ".ez-fab__tag{transform:translateY(calc(var(--ez-lift) + 24px)) translateX(8px) scale(.9);transform-origin:right center}",
    "body.ez-fab-open .ez-fab__item,body.ez-fab-open .ez-fab__tag{opacity:1;visibility:visible;pointer-events:auto;transform:translateY(var(--ez-lift));",
    "transition:opacity .2s ease,transform .32s cubic-bezier(.34,1.4,.64,1),visibility 0s}",
    "body.ez-fab-open .ez-fab__tag--cart{transition-delay:.03s}",
    "body.ez-fab-open .ez-fab__tag--gift{transition-delay:.07s}",
    /* Klaviyo's gift button is the upper choice: tucked behind My cart while closed, 44px and 58px higher when open */
    "body.ez-fab-on.ez-fab-on div.needsclick[class*='kl-teaser-']{right:15.5px!important;bottom:calc(296px + env(safe-area-inset-bottom))!important;width:44px!important;height:44px!important;",
    "opacity:0;visibility:hidden;pointer-events:none;transform:translateY(calc(var(--ez-lift) + 72px)) scale(.6);transition:opacity .16s ease,transform .2s ease,visibility 0s linear .2s!important}",
    "body.ez-fab-on.ez-fab-open div.needsclick[class*='kl-teaser-']{opacity:1;visibility:visible;pointer-events:auto;transform:translateY(var(--ez-lift));",
    "transition:opacity .2s ease .04s,transform .32s cubic-bezier(.34,1.4,.64,1) .04s,visibility 0s!important}",
    "}",
    "@media (prefers-reduced-motion:reduce){.ez-cartbtn__bag,.ez-cartbtn__x,.ez-fab__item,.ez-fab__tag,.ez-fab-dim{transition:opacity .15s ease!important}.ez-cartbtn__hub *{animation:none!important}}",

    /* ---- 3. footer end ---- */
    "@media (max-width:749px){",
    ".ezf .ezf__inner{padding-bottom:calc(16px + env(safe-area-inset-bottom))!important}",
    "body.ezp-sticky-on .ezf .ezf__inner{padding-bottom:calc(88px + env(safe-area-inset-bottom))!important}",
    "}",
    "@media (max-width:989px){body.ezc-bar-on .ezf .ezf__inner{padding-bottom:calc(84px + env(safe-area-inset-bottom))!important}}",
    "@media (prefers-reduced-motion:reduce){.ez-cartbtn,.ez-cartbtn.is-on{transition:none!important}.ez-cartbtn.is-bump .ez-cartbtn__n{animation:none}}",

    /* ---- 4. popups (Ban-26): open and close without the page jumping ----
       Desktop: Teeinblue's popups (Preview your personalization, Adjust your photo, Preview design in the cart)
       and the country picker hid the page scrollbar while open, so the whole page slid 8px sideways when they
       opened and back when they closed. With a mouse the scrollbar now stays; scrolling the page behind is
       stopped in script (section 4 below) instead. Phones keep the lock: their scrollbars take no room. */
    "@media (hover:hover) and (pointer:fine){",
    "body.vm--block-scroll{overflow:visible!important;width:auto!important}",
    "html.ezf-cs-lock,html.ezf-cs-lock body{overflow:visible!important}",
    "}",
    /* Ban-34: phones too: the country picker holds the page (html) only. The footer's own lock also hid body's
       overflow, which made body its own scroll box on phones, so the sticky header (and the open phone menu inside
       it) jumped off the screen behind the popup and came back when it closed: it looked like the menu opened again */
    "html.ezf-cs-lock body{overflow:visible!important}",
    /* Ban-135 (owner 23/10): phones too for Teeinblue's popups (Preview, See my design, Adjust your photo). Their lock
       hid body's overflow; with html{overflow-x:clip} (Ban-72) body then became its own scroll box, so the sticky
       header jumped off the screen (measured 375, page at 1050: header top 0 -> -1050) and came back on close, and
       on iPhone Safari's toolbar came back (resize -> Teeinblue redrew the Live preview). The page behind is now
       held by the touch hold in section 4 (holdOpen) instead, like the phone menu and the country picker.
       Same for teeinblue-block-scroll (popup Edit design in the cart drawer and on /cart: overflow hidden + 100vw x 100vh,
       header measured 0 -> -1050 at 320). */
    "body.vm--block-scroll,body.teeinblue-block-scroll{overflow:visible!important;width:auto!important;height:auto!important}",
    ".vm--container{overscroll-behavior:contain}",
    /* Teeinblue popups fade in and rise 10px; on close they fade and sink a little (vue-js-modal's Vue 2 class
       names: -enter / -leave-active; before, the card dropped in from 20px above and left the same way) */
    ".vm--overlay.vm-transition--overlay-enter-active,.vm--overlay.vm-transition--overlay-leave-active{transition:opacity .22s ease!important}",
    ".vm--overlay.vm-transition--overlay-enter,.vm--overlay.vm-transition--overlay-leave-active{opacity:0!important}",
    ".vm--modal.vm-transition--modal-enter-active{transition:opacity .22s ease,transform .3s cubic-bezier(.2,.9,.25,1)!important}",
    ".vm--modal.vm-transition--modal-leave-active{transition:opacity .16s ease,transform .18s ease-in!important}",
    ".vm--modal.vm-transition--modal-enter,.vm--modal.vm-transition--modal-leave-active{opacity:0!important;transform:translateY(10px) scale(.985)!important}",
    "@media (prefers-reduced-motion:reduce){.vm--modal.vm-transition--modal-enter,.vm--modal.vm-transition--modal-leave-active{transform:none!important}}"
  ].join("");

  /* gift bag with a small heart */
  var ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M5.2 8.2h13.6l-1 11.1a1.9 1.9 0 0 1-1.9 1.7H8.1a1.9 1.9 0 0 1-1.9-1.7z"/>' +
    '<path d="M8.8 8.2V6.9a3.2 3.2 0 0 1 6.4 0v1.3"/>' +
    '<path d="M12 17.6s-2.6-1.5-2.6-3.3a1.4 1.4 0 0 1 2.6-.8 1.4 1.4 0 0 1 2.6.8c0 1.8-2.6 3.3-2.6 3.3z" fill="#f06724" stroke="#f06724" stroke-width="1"/>' +
    '</svg>';
  /* Ban-31: the combined button's own icon (owner's pick "D"): an outlined sparkle with a small orange and a small
     teal star (styles and twinkle in CSS section 5), and the X it turns into when open (Ban-29) */
  var HUB = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
    '<path class="s1" d="M10 3.6l1.6 4.3a3 3 0 0 0 1.8 1.8l4.3 1.6-4.3 1.6a3 3 0 0 0-1.8 1.8L10 19l-1.6-4.3a3 3 0 0 0-1.8-1.8l-4.3-1.6 4.3-1.6a3 3 0 0 0 1.8-1.8z"/>' +
    '<path class="s2" d="M18.6 1.9l.8 2.1 2.1.8-2.1.8-.8 2.1-.8-2.1-2.1-.8 2.1-.8z"/>' +
    '<path class="s3" d="M18.4 15.2l.6 1.6 1.6.6-1.6.6-.6 1.6-.6-1.6-1.6-.6 1.6-.6z"/></svg>';
  var CLOSE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M6.5 6.5l11 11M17.5 6.5l-11 11"/></svg>';

  var st = document.createElement("style");
  st.id = "ez-floating-css";
  st.textContent = CSS;
  (document.head || document.documentElement).appendChild(st);

  /* ---- 6. The popup (Ban-36: moved here from ez-personalize.js, Ban-19 → Ban-35) ----
     One popup for the whole store: "Estimated delivery" and "Photo tips" on product pages (ez-personalize.js calls
     window.ezSheet) and the gift popup (section 7) on any page. Same backdrop, card, title, X, ways in and out, page
     hold and swipe-down. Phones: a sheet from the bottom; computers: a centred card.
     window.ezSheet({ title, sub, cls, fill(body, box), onClose(box) }) → { box, body, close } (null if one is open). */
  var SHEET_CSS = [
    "/* Ban-19: smoother and scrollable. The card is a column: head (title + X) stays put, the body scrolls.",
    "   Phones: a sheet that slides up from the bottom, at most 78% of the screen tall. Desktop: centred card,",
    "   at most 80% of the window. Only transform + opacity animate (GPU), nothing that re-lays out the page. */",
    "/* Ban-72 (§64): the page behind is no longer locked with overflow:hidden on phones. On iPhone that lock made Safari",
    "   bring its toolbar back just after the sheet had slid in, so the sheet nudged up one step. A drag behind the sheet",
    "   is still held by the touch hold below (holdOpen), so the page does not move. */",
    "/* Ban-72: on phones nothing can make the page wider than the screen (a 1–3 px overhang let the whole page be dragged",
    "   sideways on iPhone); clip, unlike hidden, keeps the sticky header and sticky parts working */",
    "@media (max-width: 989px) { html, body { overflow-x: clip; } }",
    "/* Ban-83: the Ban-81 page lock for the phone menu (html back to overflow visible so body.overflow-hidden-tablet",
    "   reached the page) is gone again. On iPhone that lock brings Safari's toolbar back, the window resizes, and",
    "   Teeinblue measures and redraws its gallery on every resize: the Live preview went white for a moment when the",
    "   menu closed (owner, 19/10). The page behind the menu is now held the way the sheets are (Ban-72): a drag or a",
    "   wheel turn only scrolls the menu's own list (holdOpen / popupOpen below), and the menu covers the screen. */",
    "/* Ban-72: the phone search box at 16 px, so iPhone does not zoom the page in when it is tapped (15 px did) */",
    "@media (max-width: 989px) { .search_form_mb input { font-size: 16px !important; } }",
    "/* Ban-34: only the page (html) is held, never body as well: with both hidden, body turned into its own scroll box on",
    "   phones and the sticky header (with the menu inside it) jumped off the screen behind the popup, then dropped back",
    "   when it closed */",
    "html.ezp-ship-open body { overflow: visible !important; }",
    "/* Ban-26: with a mouse the scrollbar stays (hiding it, even with padding in its place, moved fixed parts such as",
    "   the header by 15px); the wheel over the backdrop is held by ez-floating-buttons.js */",
    "@media (hover: hover) and (pointer: fine) { html.ezp-ship-open, html.ezp-ship-open body { overflow: visible; } }",
    ".ezp-ship { overscroll-behavior: contain; }",
    ".ezp-ship {",
    "  position: fixed;",
    "  inset: 0;",
    "  z-index: 1000;",
    "  display: flex;",
    "  align-items: center;",
    "  justify-content: center;",
    "  padding: 16px;",
    "  box-sizing: border-box;",
    "  font-family: inherit;",
    "  letter-spacing: 0;",
    "}",
    ".ezp-ship__bg { position: absolute; inset: 0; background: rgba(0, 0, 0, .55); cursor: pointer; opacity: 0; transition: opacity .25s ease; will-change: opacity; }",
    ".ezp-ship__card {",
    "  position: relative;",
    "  display: flex;",
    "  flex-direction: column;",
    "  width: min(460px, 100%);",
    "  max-height: 80vh;",
    "  max-height: 80dvh;",
    "  box-sizing: border-box;",
    "  border-radius: 16px;",
    "  background: #fff;",
    "  box-shadow: 0 24px 60px rgba(0, 0, 0, .28);",
    "  overflow: hidden;",
    "  opacity: 0;",
    "  transform: translate3d(0, 16px, 0);",
    "  transition: opacity .22s ease, transform .3s cubic-bezier(.2, .9, .25, 1);",
    "  will-change: transform, opacity;",
    "}",
    ".ezp-ship.is-in .ezp-ship__bg, .ezp-ship.is-in .ezp-ship__card { opacity: 1; }",
    ".ezp-ship.is-in .ezp-ship__card { transform: translate3d(0, 0, 0); }",
    ".ezp-ship.is-leaving .ezp-ship__bg { opacity: 0; transition-duration: .2s; }",
    ".ezp-ship.is-leaving .ezp-ship__card { opacity: 0; transform: translate3d(0, 16px, 0); transition-duration: .2s; }",
    ".ezp-ship__head { position: relative; flex: none; padding: 16px 16px 12px; border-bottom: 1px solid transparent; }",
    ".ezp-ship__head.is-scrolled { border-bottom-color: #ececec; }   /* a hairline appears once the notes are scrolled */",
    ".ezp-ship__body {",
    "  flex: 1 1 auto;",
    "  min-height: 0;",
    "  overflow-y: auto;",
    "  overscroll-behavior: contain;",
    "  -webkit-overflow-scrolling: touch;",
    "  padding: 0 16px 18px;",
    "}",
    ".ezp-ship__x {",
    "  position: absolute;",
    "  top: 10px;",
    "  right: 10px;",
    "  width: 34px;",
    "  height: 34px;",
    "  margin: 0;",
    "  padding: 0 0 2px;",
    "  border: 0;",
    "  border-radius: 50%;",
    "  background: #f5f5f5;",
    "  color: #1d1d1f;",
    "  font: inherit;",
    "  font-size: 22px;",
    "  line-height: 1;",
    "  cursor: pointer;",
    "}",
    "@media (hover: hover) { .ezp-ship__x:hover { background: #e5e5e5; } }",
    ".ezp-ship__t { margin: 0 44px; font-size: 17px; line-height: 22px; font-weight: 700; color: #1d1d1f; text-align: center; letter-spacing: 0; }",
    ".ezp-ship__s { margin: 2px 0 0; font-size: 13px; line-height: 18px; color: #6b6b6b; text-align: center; letter-spacing: 0; }",
    "/* phones: bottom sheet (grab handle, rounded top, slides up), never taller than 78% of the screen */",
    "@media (max-width: 749px) {",
    "  .ezp-ship { align-items: flex-end; padding: 0; }",
    "  .ezp-ship__card {",
    "    width: 100%;",
    "    max-height: 78vh;",
    "    max-height: 78dvh;",
    "    border-radius: 16px 16px 0 0;",
    "    padding-bottom: env(safe-area-inset-bottom);",
    "    transform: translate3d(0, 100%, 0);",
    "    opacity: 1;",
    "    transition: transform .5s cubic-bezier(.32, .72, 0, 1);",
    "  }",
    "  .ezp-ship.is-leaving .ezp-ship__card { opacity: 1; transform: translate3d(0, 100%, 0); transition: transform .3s cubic-bezier(.32, .72, 0, 1); }",
    "  /* Ban-138 (owner 23/10, iPhone test page): one soft curve for in, out and the spring-back after a pull (0.5s",
    "     cubic-bezier(.32,.72,0,1), the curve iPhone-style sheets use); was 0.32s in / 0.24s out */",
    "  .ezp-ship__bg { transition: opacity .4s cubic-bezier(.32, .72, 0, 1); }",
    "  .ezp-ship.is-leaving .ezp-ship__bg { transition: opacity .3s cubic-bezier(.32, .72, 0, 1); }",
    "  .ezp-ship__head { padding-top: 22px; }",
    "  .ezp-ship__head::before { content: \"\"; position: absolute; top: 8px; left: 50%; width: 36px; height: 4px; margin-left: -18px; border-radius: 2px; background: #d4d4d4; }",
    "  .ezp-ship__x { top: 12px; }",
    "}",
    "@media (prefers-reduced-motion: reduce) { .ezp-ship__bg, .ezp-ship__card { transition: opacity .15s ease !important; transform: none !important; } }",
    ""
  ].join("\n");
  var sheetSt = document.createElement("style");
  sheetSt.id = "ez-sheet-css";
  sheetSt.textContent = SHEET_CSS;
  (document.head || document.documentElement).appendChild(sheetSt);
  var sheetKbd = false;                                 // Ban-138: last input was a key (Tab / Enter), not a finger or mouse
  window.addEventListener("keydown", function () { sheetKbd = true; }, { capture: true, passive: true });
  window.addEventListener("pointerdown", function () { sheetKbd = false; }, { capture: true, passive: true });
  function openSheet(o) {
    if (document.querySelector(".ezp-ship")) return null;
    var box = document.createElement("div");
    box.className = "ezp-ship" + (o.cls ? " " + o.cls : "") + (o.title ? "" : " ezp-ship--bare");
    box.setAttribute("role", "dialog");
    box.setAttribute("aria-modal", "true");
    /* Ban-37: a popup can go without the title row (o.label names it for screen readers); the X and, on phones,
       the grab handle then sit over the top of the content */
    if (o.title) box.setAttribute("aria-labelledby", "ezpShipTitle");
    else box.setAttribute("aria-label", o.label || "Dialog");
    box.innerHTML =
      '<div class="ezp-ship__bg"></div>' +
      '<div class="ezp-ship__card">' +
        '<div class="ezp-ship__head">' +
        '<button type="button" class="ezp-ship__x" aria-label="Close">\u00d7</button>' +
        (o.title ? '<h3 class="ezp-ship__t" id="ezpShipTitle"></h3>' : '') +
        (o.sub ? '<p class="ezp-ship__s"></p>' : '') +
        '</div>' +
        '<div class="ezp-ship__body"></div>' +       /* Ban-19: only this part scrolls when the content is long */
      '</div>';
    if (o.title) box.querySelector(".ezp-ship__t").textContent = o.title;
    if (o.sub) box.querySelector(".ezp-ship__s").textContent = o.sub;
    var body = box.querySelector(".ezp-ship__body"), head = box.querySelector(".ezp-ship__head");
    o.fill(body, box);
    body.addEventListener("scroll", function () { head.classList.toggle("is-scrolled", body.scrollTop > 2); }, { passive: true });
    var last = document.activeElement;
    var close = function () {
      if (!box.isConnected || box.classList.contains("is-leaving")) return;
      box.classList.add("is-leaving");
      document.removeEventListener("keydown", onKey);
      setTimeout(function () {
        if (box.parentNode) box.parentNode.removeChild(box);
        document.documentElement.classList.remove("ezp-ship-open");
        document.documentElement.style.removeProperty("--ezp-sbw");
        if (last && last.focus) try { last.focus({ preventScroll: true }); } catch (err) {}
        if (o.onClose) try { o.onClose(box); } catch (err) {}
      }, 320);                                             // Ban-138: the phone slide-out is 0.3s now
    };
    var onKey = function (e) { if (e.key === "Escape") close(); };
    /* Ban-66: × and the backdrop are handled by quietClose (window, capture phase) — see below */
    box.__ezpClose = close;
    document.addEventListener("keydown", onKey);
    /* Ban-19: page scroll is locked without the page jumping: the scrollbar's width is kept as padding
       (desktop), and the popup is added first, then animated one frame later (no half-drawn first frame) */
    var sbw = window.innerWidth - document.documentElement.clientWidth;
    if (sbw > 0) document.documentElement.style.setProperty("--ezp-sbw", sbw + "px");
    document.body.appendChild(box);
    document.documentElement.classList.add("ezp-ship-open");
    /* Ban-66: no forced layout inside the tap (it cost ~25 ms here): the slide-in starts two frames later */
    requestAnimationFrame(function () { requestAnimationFrame(function () { box.classList.add("is-in"); }); });
    swipeSheet(box.querySelector(".ezp-ship__card"), { sheet: ".ezp-ship.is-in:not(.is-leaving) .ezp-ship__card", scroll: ".ezp-ship__body", bg: ".ezp-ship__bg", close: ".ezp-ship__x" });   /* Ban-28 §39 */
    /* Ban-138: the X takes the focus only for keyboard users, once the sheet is in. On a phone the focus at 0.3s landed
       while the sheet was still sliding (a suspect for the small nudge at the end of the slide on iPhone) */
    if (sheetKbd) setTimeout(function () { try { box.querySelector(".ezp-ship__x").focus({ preventScroll: true }); } catch (err) {} }, 520);
    return { box: box, body: body, close: close };
  }

  /* 39. Ban-28 — bottom sheets on phones close with a downward swipe, like TikTok / Facebook comment sheets:
         "Estimated delivery" (§37) and "Photo tips". Hold anywhere on the sheet and pull down: it follows the finger
         and the dark backdrop fades with it. Let go past a quarter of its height (or with a quick flick) and it
         slides away, then the sheet's own X is pressed, so it closes exactly as before; otherwise it springs back.
         A list inside the sheet scrolls first; the sheet only follows once that list is back at its top.
         Only while the popup really sits at the bottom of the screen (phones); a centred popup is left alone.
         The listeners sit on the sheet itself, so scrolling the rest of the page is never held up. */
  function swipeSheet(el, c) {
    if (!el || el.__ezpSwipe) return;
    el.__ezpSwipe = true;
    var g = null, tidyT = 0, EASE = "cubic-bezier(.32, .72, 0, 1)";
    function atBottom() {
      var r = el.getBoundingClientRect(), w = document.documentElement.clientWidth;
      return r.left <= 1 && r.right >= w - 1 && r.bottom >= window.innerHeight - 2 && r.height > 80;
    }
    /* Ban-138: the release is a CSS transition on the same inline style (was el.animate() with fill "forwards", then the
       inline styles were cleared and the animation cancelled in one go: on iPhone Safari the stylesheet transition then
       restarted from where the finger had left the sheet, so it dropped back and slid up again, owner 23/10). The
       inline styles are removed only once the sheet already sits where the stylesheet puts it, with transitions off for
       that one frame, so nothing restarts. */
    function tidyLater(bg, ms) {
      clearTimeout(tidyT);
      tidyT = setTimeout(function () {
        el.style.transition = "none";
        el.style.transform = "";
        if (bg) { bg.style.transition = "none"; bg.style.opacity = ""; }
        requestAnimationFrame(function () { el.style.transition = ""; if (bg) bg.style.transition = ""; });
      }, ms);
    }
    el.addEventListener("touchstart", function (e) {
      g = null;
      if (e.touches.length !== 1 || !el.matches(c.sheet) || !atBottom()) return;
      var t = e.target;
      if (t.closest && t.closest("input, textarea, select, [contenteditable], " + c.close)) return;
      var p = e.touches[0];
      g = { bg: document.querySelector(c.bg), scroller: t.closest && t.closest(c.scroll), x0: p.clientX, y0: p.clientY, y1: 0, dy: 0, mode: 0, h: el.offsetHeight, ly: p.clientY, lt: e.timeStamp, v: 0 };
    }, { passive: true });
    el.addEventListener("touchmove", function (e) {
      if (!g) return;
      if (e.touches.length !== 1) { end(); return; }
      var p = e.touches[0], dx = p.clientX - g.x0, dy = p.clientY - g.y0;
      if (g.mode === 0) {                                  // not decided yet
        /* Ban-30: a pull downwards with the list at its top belongs to the sheet from the first pixel, so the
           browser never starts scrolling anything behind it */
        if (dy > 0 && Math.abs(dy) >= Math.abs(dx) && !(g.scroller && g.scroller.scrollTop > 0) && e.cancelable) e.preventDefault();
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        if (dy <= 0 || Math.abs(dx) > Math.abs(dy) || (g.scroller && g.scroller.scrollTop > 0)) { g = null; return; }
        g.mode = 1;
        g.y1 = p.clientY;                                  // follow from here, so the sheet does not jump
        clearTimeout(tidyT);
        /* caught again while springing back: hold it where it is now and follow from there */
        var now = getComputedStyle(el).transform, m = /matrix\(([^)]+)\)/.exec(now);
        el.style.transition = "none";
        if (m) { el.style.transform = now; g.y1 -= parseFloat(m[1].split(",")[5]) || 0; }
        if (g.bg) g.bg.style.transition = "none";
      }
      if (e.cancelable) e.preventDefault();
      var d = p.clientY - g.y1;
      d = d < 0 ? d / 4 : d;                               // a little give when pulled up
      g.dy = d;
      var dt = e.timeStamp - g.lt;
      if (dt > 0) { g.v = (p.clientY - g.ly) / dt; g.ly = p.clientY; g.lt = e.timeStamp; }
      el.style.transform = "translate3d(0," + Math.round(d * 10) / 10 + "px,0)";
      if (g.bg) g.bg.style.opacity = String(Math.max(0, 1 - Math.max(0, d) / g.h));
    }, { passive: false });
    function end() {
      var s = g;
      g = null;
      if (!s || s.mode !== 1) return;
      if (s.dy > s.h * 0.25 || (s.v > 0.5 && s.dy > 24)) {
        /* Ban-33: on down from where the finger let go, never back up; then the sheet's own X closes it as usual */
        el.style.transition = "transform .3s " + EASE;
        el.style.transform = "translate3d(0," + Math.max(s.h, Math.round(s.dy) + 40) + "px,0)";
        if (s.bg) { s.bg.style.transition = "opacity .3s " + EASE; s.bg.style.opacity = "0"; }
        setTimeout(function () {
          var x = el.querySelector(c.close);
          if (x) x.click();
          tidyLater(s.bg, 420);
        }, 300);
      } else {
        el.style.transition = "transform .5s " + EASE;
        el.style.transform = "translate3d(0,0,0)";
        if (s.bg) { s.bg.style.transition = "opacity .5s " + EASE; s.bg.style.opacity = "1"; }
        tidyLater(s.bg, 520);
      }
    }
    el.addEventListener("touchend", end);
    el.addEventListener("touchcancel", end);
  }
  window.ezSheet = openSheet;
  /* Ban-155: the same pull-down-to-close for the country / currency picker (ez-footer.js, a <dialog> shown as a bottom
     sheet on phones). Its dimmed backdrop is the dialog's ::backdrop, so only the sheet follows the finger. */
  window.ezSwipeSheet = swipeSheet;
  /* Ban-66: Facebook Pixel listens to every click on the document (capture phase) and, on this page, spends 50–180 ms
     reading the page around what was clicked before anything else can happen: the mouse stalls. Clicks on the popup's
     × and backdrop are taken one step earlier, on the window, and stop there: the popup closes at once and the pixel
     never runs for them. */
  window.addEventListener("click", function (e) {
    var t = e.target && e.target.closest ? e.target.closest(".ezp-ship__x, .ezp-ship__bg") : null;
    if (!t) return;
    var box = t.closest(".ezp-ship");
    if (!box || !box.__ezpClose) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    box.__ezpClose();
  }, true);

  /* ---- 7. Gift popup (Ban-36) ----
     The gift button opens the shared popup (section 6) with the store's own footer sign-up form in it (Klaviyo form
     SNWH2R, the same one as in the footer: one form, one code setup, one welcome flow). Klaviyo draws that form only
     once per page, so the footer's form itself is moved into the popup while it is open and put back when it closes
     (behind the dark backdrop, so the footer never looks empty). The code appears right there, a tap copies it
     (ez-footer.js), and Klaviyo applies it to the cart by itself: nobody is sent to another page.
     Gift button: the same gift picture as before, in the same place (section 2); on every page except product
     pages, cart, checkout and order pages (as Klaviyo's rules were). It shows once the footer form is ready, or
     when a code was already shown on this device (then it opens that code again).
     Opens by itself only on computers, when the mouse leaves the window, at most once every 7 days, and never once a
     code has been shown. Phones: only when tapped. */
  var OLD_GIFT = "WscvEm";
  /* Ban-184 (anh 26/10/2026): section 7 switched OFF. After TEST 13 went live (26/10) Klaviyo's "Sign up" popup
     (WscvEm: 5 s + 30% scroll or exit intent, 5-day cookie, not on product/cart/checkout pages) was hidden here and
     the EZ gift button only opened when tapped (phones) / on exit intent once a week (computers): sign-ups to the
     Welcome list fell from 37 + 44 a day (25/10) to ~0 after the switch. With GIFT_OFF Klaviyo's own popup and gift
     teaser work exactly as on the old theme (the teaser sits in the right-hand column, sections 2 and 5); the EZ gift
     button, its popup and its exit intent are not built. The popup's look is edited in Klaviyo (form WscvEm).
     Set to false to bring section 7 back. */
  var GIFT_OFF = true;
  var GIFT_CSS = [
    "/* ---- 7. Gift popup (Ban-36) ---- */",
    "/* Klaviyo's old \"Sign up\" popup (form WscvEm) and its gift button are not used by this theme: hidden here, so the",
    "   store's other themes (LIVE) keep them until the form is switched off in Klaviyo */",
    "div.needsclick[class*='kl-teaser-WscvEm']{display:none!important}",
    ".ez-gift__btn{display:block;overflow:hidden;box-sizing:border-box;width:100%;height:100%;padding:8px;border-radius:50%;cursor:pointer;background:transparent url(\"https://d3k81ch9hvuctc.cloudfront.net/company/UdejyK/images/1e7bf70d-9232-4c02-ad1d-64645a0def0c.png\") center/contain no-repeat;-webkit-tap-highlight-color:transparent}",
    ".ez-gift__btn:focus-visible{outline:2px solid #02aeb8;outline-offset:3px}",
    /* Ban-37: no title row; the band is the top of the card (the X and the grab handle sit over it) */
    ".ezp-ship--bare .ezp-ship__head{position:absolute;top:0;left:0;right:0;z-index:2;height:0;padding:0;border:0}",
    ".ezp-ship--gift .ezp-ship__body{padding-top:0}",
    ".ez-gift__band{margin:0 -16px 14px;padding:26px 52px 16px;text-align:center;background:linear-gradient(110deg,#fff1e8 0%,#fff 55%,#e6f6f7 100%)}",
    ".ez-gift__big{margin:0;font-size:min(28px,7.4vw);line-height:1.2;font-weight:700;letter-spacing:-.01em;color:#1d1d1f;white-space:nowrap}",
    ".ez-gift__big b{color:#f06724;font-weight:800}",
    ".ez-gift__sub{margin:6px 0 0;font-size:min(14px,3.75vw);line-height:1.5;color:#404040;white-space:nowrap}",
    ".ezp-ship--gift.is-done .ez-gift__big{font-size:min(24px,6.4vw)}",
    /* Ban-37: under the code, said plainly: Klaviyo applies it by itself */
    /* Ban-39: the success step between Ban-37 (teal everywhere, glaring) and Ban-38 (near-black, too dark):
       dark text; a light teal frame for the code; the button in the store's orange, as the email step's button and Add to cart */
    ".ez-gift__auto{display:flex;align-items:center;justify-content:center;gap:6px;margin:10px 0 0;font-size:13px;line-height:1.4;font-weight:500;color:#404040;text-align:center}",
    ".ez-gift__auto svg{flex:none;width:16px;height:16px;color:#0b8a93}",
    ".ez-gift__fine{margin:10px 0 0;font-size:12px;line-height:1.5;color:#6b6b6b;text-align:center}",
    ".ez-gift__more{display:block;width:100%;height:48px;margin:14px 0 0;border:0;border-radius:10px;background:#f06724;color:#fff;font:inherit;font-size:16px;font-weight:600;cursor:pointer;transition:background-color .15s ease}",
    "@media (hover:hover){.ez-gift__more:hover{background:#dc5a1b}}",
    ".ez-gift__more:focus-visible{outline:2px solid #f06724;outline-offset:2px}",
    ".ezp-ship--gift.is-done .ez-gift__fine{display:none}",
    "/* the store's footer form, shown in the popup: only its field, button and code (its own texts are replaced by",
    "   the band above); same look as in the footer */",
    ".ezp-ship--gift .klaviyo-form-richtext,.ezp-ship--gift [data-testid='form-row']:has(.klaviyo-form-richtext){display:none!important}",
    ".ezp-ship--gift form>div{min-height:0!important;background:transparent!important}",
    ".ezp-ship--gift [data-testid='form-component']{padding-top:4px!important;padding-bottom:4px!important}",
    ".ezp-ship--gift input[type='email']{height:48px!important;border:1.5px solid #d4d4d4!important;border-radius:10px!important;font-size:16px!important;transition:border-color .15s ease,box-shadow .15s ease!important}",
    ".ezp-ship--gift input[type='email']:focus{border-color:#02aeb8!important;box-shadow:0 0 0 3px rgba(2,174,184,.2)!important;outline:none!important}",
    ".ezp-ship--gift input[type='email'][data-ezf-invalid]{border-color:#c5221f!important;box-shadow:0 0 0 3px rgba(197,34,31,.14)!important}",
    ".ezp-ship--gift .klaviyo-form-button{width:100%!important;height:48px!important;border-radius:10px!important;background:#f06724!important;color:#fff!important;font-size:16px!important;font-weight:600!important}",
    ".ezp-ship--gift [data-testid='form-component']:has(>.ezf-email-msg){flex-wrap:wrap!important}",
    ".ezp-ship--gift .ezf-email-msg{flex:1 0 100%;margin:6px 2px 0;font-size:13px;line-height:1.4;text-align:left;color:#404040}",
    ".ezp-ship--gift .ezf-email-msg[hidden]{display:none}",
    ".ezp-ship--gift .ezf-email-msg.is-error{color:#c5221f}",
    ".ezp-ship--gift .ezf-email-fix{margin:0;padding:0;border:0;background:none;color:#00707a;font:inherit;font-weight:600;text-decoration:underline;text-underline-offset:2px;cursor:pointer}",
    ".ezp-ship--gift .klaviyo-coupon,.ez-gift__saved{position:relative}",
    ".ezp-ship--gift .klaviyo-coupon button,.ez-gift__code{display:flex!important;align-items:center!important;justify-content:center!important;gap:12px!important;width:100%;min-height:52px!important;margin:0;padding:8px 12px 8px 16px!important;border:1.5px dashed #7ccdd2!important;border-radius:10px!important;background:#f3fbfb!important;color:#1d1d1f!important;cursor:pointer!important;font:inherit}",
    ".ezp-ship--gift .klaviyo-coupon button:hover,.ezp-ship--gift .klaviyo-coupon.is-copied button,.ez-gift__code:hover,.ez-gift__saved.is-copied .ez-gift__code{background:#e8f6f7!important}",
    ".ezp-ship--gift .klaviyo-coupon.is-copied button,.ez-gift__saved.is-copied .ez-gift__code{border-style:solid!important;border-color:#2aa9b1!important}",
    ".ezp-ship--gift .klaviyo-coupon button>div,.ez-gift__code span{color:#1d1d1f!important;font-size:22px!important;font-weight:700!important;line-height:1.2!important;letter-spacing:.08em!important;white-space:nowrap!important;-webkit-user-select:all;user-select:all}",
    ".ezp-ship--gift .klaviyo-coupon button>svg{flex:none;width:24px!important;height:24px!important;color:#0b8a93!important}",
    ".ezp-ship--gift .klaviyo-coupon button>svg *{stroke:#0b8a93!important}",
    ".ezp-ship--gift .klaviyo-coupon button:focus-visible{box-shadow:0 0 0 2px #fff,0 0 0 4px #0b8a93!important;outline:none!important}",
    ".ezp-ship--gift .ezf-copied,.ez-gift__tip{position:absolute;left:50%;bottom:calc(100% + 6px);transform:translateX(-50%);padding:7px 10px;border-radius:8px;background:#1d1d1f;color:#fff;font:600 12px/1 inherit;white-space:nowrap;pointer-events:none;opacity:0;transition:opacity .15s ease}",
    ".ezp-ship--gift .ezf-copied.is-on,.ez-gift__tip.is-on{opacity:1}",
    ".ezp-ship--gift .ezf-coupon-hint,.ez-gift__hint{display:block;margin-top:6px;color:#6b6b6b;font-size:12px;line-height:1.4;text-align:center}",
    ".ezp-ship--gift .klaviyo-coupon.is-copy-failed .ezf-coupon-hint{color:#b23c1f;font-weight:600}",
    /* Ban-37: the footer's "paste it at checkout" hint does not fit here (the code is applied by itself): the
       "Copied!" bubble is the feedback; the hint only shows if copying failed */
    ".ezp-ship--gift .ezf-coupon-hint,.ez-gift__hint{display:none!important}",
    ".ezp-ship--gift .klaviyo-coupon.is-copy-failed .ezf-coupon-hint,.ez-gift__saved.is-failed .ez-gift__hint{display:block!important;color:#b23c1f;font-weight:600}",
    ".ez-gift__code svg{flex:none;width:22px;height:22px;color:#0b8a93}",
    /* Ban-124: the code now goes out by e-mail. Email step: the form's own first-name field is not shown here (it is
       optional; the footer keeps it). Success: no band, the footer's "Check your inbox" panel (ez-footer.js 3d) in
       the popup's size, one orange button, and the mail app link under it */
    ".ezp-ship--gift [data-testid='form-row']:has(input[type='text']){display:none!important}",
    ".ezp-ship--gift.is-sent .ez-gift__band{display:none}",
    ".ezp-ship--gift.is-sent .ezp-ship__body{padding-top:42px}",
    ".ezp-ship--gift .ezf-sent{display:flex!important;padding:0!important;text-align:center!important}",
    ".ezp-ship--gift .ezf-sent__icon{width:64px!important;height:64px!important;border:0!important;background:#effbfc!important}",
    ".ezp-ship--gift .ezf-sent__icon>svg{width:32px!important;height:32px!important}",
    ".ezp-ship--gift .ezf-sent__tick{width:24px!important;height:24px!important}",
    ".ezp-ship--gift .ezf-sent__tick svg{width:12px!important;height:12px!important}",
    ".ezp-ship--gift .ezf-sent__title{margin-top:16px!important;font-size:22px!important;line-height:28px!important}",
    ".ezp-ship--gift .ezf-sent__lead{margin-top:8px!important;font-size:15px!important;line-height:22px!important}",
    ".ezp-ship--gift .ezf-sent__lead b{display:block}",
    ".ezp-ship--gift .ezf-sent__tail{display:block!important;margin-top:4px!important;font-size:13px!important;line-height:18px!important;color:#404040!important}",
    ".ezp-ship--gift .ezf-sent__note{width:100%;box-sizing:border-box;margin-top:16px!important;padding:10px 12px 10px 36px;border:1px solid #a9e4e9;border-radius:10px;background:#effbfc url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='%230a636b' stroke-width='1.8' stroke-linecap='round'%3E%3Ccircle cx='8' cy='8' r='6.5'/%3E%3Cpath d='M8 7.3v3.6M8 5.1v.1'/%3E%3C/svg%3E\") no-repeat 12px 11px/16px 16px;font-size:13px!important;line-height:18px!important;color:#0a636b!important;text-align:left}",
    ".ezp-ship--gift .ezf-sent__app{display:none!important}",
    ".ezp-ship--gift.is-sent .ez-gift__more{height:52px;margin-top:16px;border-radius:999px;font-size:18px;font-weight:700}",
    ".ez-gift__app{display:flex;align-items:center;justify-content:center;gap:6px;width:max-content;min-height:44px;margin:6px auto 0;color:#0b7f89;font-size:15px;font-weight:600;text-decoration:underline;text-underline-offset:3px}",
    ".ez-gift__app svg{width:14px;height:14px}",
    "@media (hover:hover){.ez-gift__app:hover{color:#0a636b}}",
    "@media (min-width:750px){.ezp-ship--gift.is-sent .ezp-ship__body{padding-top:44px}.ezp-ship--gift .ezf-sent__title{font-size:26px!important;line-height:32px!important}.ezp-ship--gift .ezf-sent__icon{width:72px!important;height:72px!important}.ezp-ship--gift .ezf-sent__lead b{display:inline}}"
  ].join("\n");
  (function gift() {
    if (GIFT_OFF) return;   /* Ban-184 */
    var giftSt = document.createElement("style");
    giftSt.id = "ez-gift-css";
    giftSt.textContent = GIFT_CSS;
    (document.head || document.documentElement).appendChild(giftSt);

    /* Klaviyo's old popup may still open by itself here: keep it out of sight and give the page back */
    function hideOld() {
      var f = document.querySelector("form[data-testid='klaviyo-form-" + OLD_GIFT + "']");
      if (!f) return;
      var top = f;
      while (top.parentElement && top.parentElement !== document.body) top = top.parentElement;
      if (top !== document.body && top.style.display !== "none") top.style.display = "none";
      document.body.classList.remove("klaviyo-prevent-body-scrolling");
      document.documentElement.classList.remove("klaviyo-prevent-body-scrolling");
    }
    var oldFrame = 0;
    new MutationObserver(function () {
      if (!oldFrame) oldFrame = requestAnimationFrame(function () { oldFrame = 0; hideOld(); });
    }).observe(document.documentElement, { childList: true, subtree: true });

    if (/(^|\/)products\/|^\/(cart|checkout)(\/|$)|\/orders\/|^\/a\/track-order/.test(path)) return;

    var BLOCK = ".footer-container .shopify-app-block[id*='klaviyo_email_marketing_sms_form_embed_block']";
    var KEY = "ez-gift", AUTO = "ez-gift-auto", SENT = "ez-gift-sent";
    function get(k, store) { try { return JSON.parse((store || localStorage).getItem(k)); } catch (e) { return null; } }
    function put(k, v, store) { try { (store || localStorage).setItem(k, JSON.stringify(v)); } catch (e) {} }
    /* Ban-38: a real code only. Klaviyo first shows "Loading coupon…" in the code box and fills in the code a moment
       later; Ban-36/37 kept the first text it saw, so reopening the popup showed "Loading coupon" */
    function isCode(t) { return /^[A-Z0-9][A-Z0-9_-]{3,39}$/i.test(t || "") && !/loading/i.test(t); }
    function saved() { var s = get(KEY); return s && isCode(s.code) ? s : null; }
    /* Ban-124: signed up on this device and the code went out by e-mail: no gift button, no popup by itself */
    function sent() { return !!get(SENT); }
    var block = null, home = null, sheet = null, watch = null, btnEl = null;

    function findBlock() {
      if (block && block.isConnected) return block;
      block = document.querySelector(BLOCK);
      return block;
    }
    function formReady() { var b = findBlock(); return !!(b && b.querySelector("form")); }

    function text(el, html) { el.innerHTML = html; return el; }
    /* Ban-37: short texts, each on one line on phones; no "Your gift" title row above them */
    function band(body, done) {
      var b = body.querySelector(".ez-gift__band") || body.insertBefore(document.createElement("div"), body.firstChild);
      b.className = "ez-gift__band";
      if (done) text(b, '<p class="ez-gift__big"><b>10% off</b> unlocked</p><p class="ez-gift__sub">We\u2019ve also emailed your code.</p>');
      else text(b, '<p class="ez-gift__big">Get <b>10% off</b></p><p class="ez-gift__sub">We\u2019ll email you a 10% off code.</p>');
    }
    function autoLine(body, after) {
      if (body.querySelector(".ez-gift__auto")) return;
      var a = document.createElement("p");
      a.className = "ez-gift__auto";
      a.innerHTML = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3.5 8.5l3 3 6-7"/></svg>' +
        '<span>Applied automatically at cart &amp; checkout</span>';
      if (after && after.parentNode === body) body.insertBefore(a, after.nextSibling); else body.appendChild(a);
    }
    function moreButton(body) {
      if (body.querySelector(".ez-gift__more")) return;
      var m = document.createElement("button");
      m.type = "button";
      m.className = "ez-gift__more";
      m.textContent = "Continue shopping";
      m.addEventListener("click", function () { if (sheet) sheet.close(); });
      body.appendChild(m);
    }
    function copy(code) {
      if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(code).then(function () { return true; }, function () { return false; });
      return Promise.resolve(false);
    }
    /* a code shown before on this device (the footer form is not drawn again for someone who signed up) */
    function savedView(body, s) {
      band(body, true);
      var w = document.createElement("div");
      w.className = "ez-gift__saved";
      w.innerHTML = '<span class="ez-gift__tip" aria-hidden="true">Copied!</span><button type="button" class="ez-gift__code" aria-label="Copy the code"><span></span>' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="9" y="9" width="11" height="11" rx="2"/><path d="M5 15V6a2 2 0 0 1 2-2h9"/></svg></button>' +
        '<span class="ez-gift__hint" role="status" aria-live="polite">Tap the code to copy it.</span>';
      w.querySelector(".ez-gift__code span").textContent = s.code;
      w.querySelector(".ez-gift__code").addEventListener("click", function () {
        copy(s.code).then(function (ok) {
          var hint = w.querySelector(".ez-gift__hint"), tip = w.querySelector(".ez-gift__tip");
          if (ok) {
            w.classList.add("is-copied"); w.classList.remove("is-failed"); tip.classList.add("is-on"); hint.textContent = "Code copied.";
            setTimeout(function () { tip.classList.remove("is-on"); }, 2000);
          } else {
            try { var r = document.createRange(); r.selectNodeContents(w.querySelector(".ez-gift__code span")); var sel = getSelection(); sel.removeAllRanges(); sel.addRange(r); } catch (e) {}
            w.classList.add("is-failed");
            hint.textContent = "The code is selected: copy it, or write it down.";
          }
        });
      });
      body.appendChild(w);
      autoLine(body, w);
      moreButton(body);
    }
    /* the success step: switch the band as soon as Klaviyo shows its code box; keep the code once it is real */
    function onDone(body, box) {
      if (block && block.querySelector(".ezf-sent")) {
        /* Ban-124: code sent by e-mail (footer panel, ez-footer.js 3d) */
        if (box.classList.contains("is-sent")) return;
        box.classList.add("is-done", "is-sent");
        put(SENT, Date.now());
        moreButton(body);
        var app = block.querySelector(".ezf-sent__app");
        if (app && !body.querySelector(".ez-gift__app")) {
          var a = app.cloneNode(true);
          a.className = "ez-gift__app";
          body.appendChild(a);
        }
        return;
      }
      if (!block || !block.querySelector(".klaviyo-coupon")) return;
      var c = block.querySelector(".klaviyo-coupon button > div");
      var code = c ? c.textContent.trim() : "";
      var s = saved();
      if (isCode(code) && (!s || s.code !== code)) put(KEY, { code: code, t: Date.now() });
      if (box.classList.contains("is-done")) return;
      box.classList.add("is-done");
      band(body, true);
      autoLine(body, block);
      moreButton(body);
    }
    function openGift() {
      if (document.querySelector(".ezp-ship") || !window.ezSheet) return;
      var s = saved();
      var live = formReady();
      if (!live && !s) return;
      sheet = window.ezSheet({
        label: "Your gift: 10% off your order",
        cls: "ezp-ship--gift",
        fill: function (body, box) {
          var hasCoupon = live && !!block.querySelector(".klaviyo-coupon");
          if (live) {
            /* the footer's own form, still asking for the email or (Ban-38: also on a reopen in the same visit)
               already showing Klaviyo's code box, which always holds the real code */
            band(body, hasCoupon);
            home = document.createComment("ez-gift-home");
            block.parentNode.insertBefore(home, block);
            body.appendChild(block);
            var fine = document.createElement("p");
            fine.className = "ez-gift__fine";
            fine.textContent = "One code per customer. Unsubscribe anytime.";
            body.appendChild(fine);
            watch = new MutationObserver(function () { onDone(body, box); });
            watch.observe(block, { childList: true, subtree: true, characterData: true });
            onDone(body, box);
          } else if (s) savedView(body, s);
        },
        onClose: function () {
          if (watch) { watch.disconnect(); watch = null; }
          if (home && home.parentNode) { home.parentNode.insertBefore(block, home); home.parentNode.removeChild(home); }
          home = null;
          sheet = null;
          check();
        }
      });
    }

    /* the gift button: Klaviyo's teaser markup and classes, so the right-hand column and the combined button
       (sections 2 and 5) treat it exactly as before */
    function buildBtn() {
      btnEl = document.createElement("div");
      btnEl.className = "needsclick kl-teaser-ezgift ez-gift";
      btnEl.style.cssText = "z-index:90000;position:fixed;filter:drop-shadow(rgba(0,0,0,.15) 0 0 30px);bottom:0;left:0;margin:20px;height:84px;width:84px";
      /* Ban-38: no "hide" ×: the gift button always stays */
      btnEl.innerHTML = '<div style="height:100%;width:100%"><span class="needsclick ez-gift__btn" role="button" tabindex="0" aria-label="Your gift: 10% off your order"></span></div>';
      var open = btnEl.querySelector(".ez-gift__btn");
      open.addEventListener("click", openGift);
      open.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); openGift(); } });
      document.body.appendChild(btnEl);
    }
    function check() {
      var want = (formReady() && !sent()) || !!saved();
      if (want && !btnEl) buildBtn();
      if (!want && btnEl) { btnEl.parentNode.removeChild(btnEl); btnEl = null; }
    }
    /* Ban-124: signed up in the footer form (not in the popup): same as in the popup, the gift button goes */
    window.addEventListener("ezf:sent", function () {
      put(SENT, Date.now());
      if (!sheet) check();
    });
    /* Klaviyo draws the footer form a little after the page: look for it for up to 20 seconds */
    var tries = 0;
    (function look() {
      if (!document.body) { setTimeout(look, 200); return; }
      check();
      if (!formReady() && ++tries < 40) setTimeout(look, 500);
    })();

    /* computers: once when the mouse leaves the window, not more than every 7 days, never after a code was shown */
    var t0 = Date.now();
    document.addEventListener("mouseout", function (e) {
      if (e.relatedTarget || e.clientY > 0 || Date.now() - t0 < 5000) return;
      if (!window.matchMedia || !window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;
      if (!btnEl || saved() || sent() || !formReady()) return;
      var last = get(AUTO);
      if (last && Date.now() - last < 7 * 864e5) return;
      if (document.querySelector(".ezp-ship, dialog[open], .vm--container") || document.documentElement.classList.contains("ezf-cs-lock")) return;
      put(AUTO, Date.now());
      openGift();
    });
  })();

  /* mobile menu open/closed → body class (the theme's own class covers the Dawn drawer; this also covers a
     custom menu that only toggles [open] on the header's <details>) */
  function watchMenu() {
    var menu = document.querySelector("header-drawer details, .menu-drawer-container, details[id*='Details-menu-drawer']");
    if (!menu) return;
    var sync = function () {
      var open = menu.hasAttribute("open");
      document.body.classList.toggle("ez-menu-open", open);   // Ban-83: no class on <html> any more (one style pass less per open)
    };
    new MutationObserver(sync).observe(menu, { attributes: true, attributeFilter: ["open"] });
    sync();
  }

  /* "at the end of the page" flag (used just above) */
  var endFrame = 0;
  function markEnd() {
    endFrame = 0;
    var d = document.documentElement;
    if (document.body) document.body.classList.toggle("ez-at-end", window.innerHeight + (window.pageYOffset || d.scrollTop || 0) >= d.scrollHeight - 140);
  }
  function queueEnd() { if (!endFrame) endFrame = requestAnimationFrame(markEnd); }

  /* Ban-15: "the personalisation form is on screen" flag (all screens since Ban-29). The form appears a little after load
     (Teeinblue draws it), so look for it for up to 20 seconds. */
  (function watchForm() {
    if (!("IntersectionObserver" in window)) return;
    var tries = 0;
    (function look() {
      var form = document.getElementById("tee-artwork-form");
      if (!form) { if (++tries < 40) setTimeout(look, 500); return; }
      new IntersectionObserver(function (entries) {
        var e = entries[entries.length - 1];
        if (document.body) document.body.classList.toggle("ez-in-form", e.isIntersecting);
      }, { rootMargin: "0px 0px -60px 0px" }).observe(form);
    })();
  })();
  window.addEventListener("scroll", queueEnd, { passive: true });
  window.addEventListener("resize", queueEnd);

  if (onCart) {            /* no cart button on the cart page; the Klaviyo + footer rules above still apply */
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", watchMenu); else watchMenu();
    return;
  }

  var mq = window.matchMedia("(max-width: 989px)");
  var btn = null, num = null, on = null, last = -1, frame = 0;

  function count() {
    var b = document.getElementById("header-cart-count-bubble") || document.querySelector("#cart-icon-bubble .cart-count-bubble span, .cart-count-bubble span");
    var n = b ? parseInt(b.textContent, 10) : 0;
    return isNaN(n) ? 0 : n;
  }
  function headerBottom() {
    var h = document.querySelector(".section-header") || document.querySelector("header");
    return h ? h.offsetHeight : 64;
  }
  function build() {
    btn = document.createElement("a");
    btn.className = "ez-cartbtn";
    btn.href = (window.routes && window.routes.cart_url) || "/cart";
    btn.title = "My cart";
    btn.tabIndex = -1;
    btn.innerHTML = '<span class="ez-cartbtn__circle"><span class="ez-cartbtn__bag">' + ICON + '</span><span class="ez-cartbtn__x">' + CLOSE + '</span>' +
      '<span class="ez-cartbtn__hub">' + HUB + '</span><span class="ez-cartbtn__n" aria-hidden="true"></span></span>' +
      '<span class="ez-cartbtn__label" aria-hidden="true">My cart</span>';
    num = btn.querySelector(".ez-cartbtn__n");
    btn.addEventListener("click", function (e) {         /* Ban-29: the combined button (phones) opens instead of leaving */
      if (!fabOn) return;
      e.preventDefault();
      setOpen(!fabOpen);
    });
    document.body.appendChild(btn);
  }

  /* 5. My cart + gift in one button (Ban-29, phones; CSS section 5). Only while My cart shows AND Klaviyo shows its
     gift on this page. Klaviyo still decides where the gift appears; its own button is reused as the upper choice,
     so a tap on it opens Klaviyo's form exactly as before. */
  var fabOn = false, fabOpen = false, fabY = 0, dim = null, item = null, tagCart = null, tagGift = null;
  var giftSeen = false;
  /* Ban-36: Klaviyo's old teaser left out; Ban-184: with section 7 off it is the gift button again */
  var TEASER = GIFT_OFF ? "div.needsclick[class*='kl-teaser-']" : "div.needsclick[class*='kl-teaser-']:not([class*='kl-teaser-" + OLD_GIFT + "'])";
  function teaser() {
    var t = document.querySelector(TEASER);
    return t && t.offsetHeight > 0 ? t : null;
  }
  /* Ban-30: once Klaviyo has shown its gift on this page, keep the combined button while its gift button is
     still in the page (it can be hidden for a moment, e.g. while its own form is open); it goes back to the plain
     My cart only if Klaviyo removes the gift (closed or signed up) */
  function hasGift() {
    var t = document.querySelector(TEASER);
    if (t && t.offsetHeight > 0) giftSeen = true;
    if (!t) giftSeen = false;
    return giftSeen;
  }
  var ASIDE = ["ez-in-form", "ez-at-end", "ezp-modal-open", "ezp-ai-open", "ez-menu-open", "overflow-hidden", "overflow-hidden-mobile", "overflow-hidden-tablet", "klaviyo-prevent-body-scrolling"];
  function stepAside() {
    var c = document.body.classList;
    for (var i = 0; i < ASIDE.length; i++) if (c.contains(ASIDE[i])) return true;
    return document.documentElement.classList.contains("ezp-ship-open");
  }
  function buildFab() {
    var href = btn.href;
    dim = document.createElement("div");
    dim.className = "ez-fab-dim";
    dim.addEventListener("click", function () { setOpen(false); });
    item = document.createElement("a");
    item.className = "ez-fab__item";
    item.href = href;
    item.tabIndex = -1;
    item.setAttribute("aria-label", "Go to my cart");
    item.innerHTML = ICON;
    tagCart = document.createElement("a");
    tagCart.className = "ez-fab__tag ez-fab__tag--cart";
    tagCart.href = href;
    tagCart.tabIndex = -1;
    tagCart.innerHTML = "My cart <b></b>";
    tagGift = document.createElement("button");
    tagGift.type = "button";
    tagGift.className = "ez-fab__tag ez-fab__tag--gift";
    tagGift.tabIndex = -1;
    tagGift.textContent = "Your gift";
    tagGift.addEventListener("click", function () {      /* the name opens Klaviyo's form too */
      var t = teaser(), hit = t && (t.querySelector("span.needsclick") || t.firstElementChild || t);
      setOpen(false);
      if (hit) hit.click();
    });
    [dim, item, tagCart, tagGift].forEach(function (el) { document.body.appendChild(el); });
  }
  function setOpen(v) {
    if (!btn || fabOpen === v) return;
    fabOpen = v;
    fabY = window.pageYOffset || document.documentElement.scrollTop || 0;
    document.body.classList.toggle("ez-fab-open", v);
    btn.setAttribute("aria-expanded", String(v));
    [item, tagCart, tagGift].forEach(function (el) { if (el) el.tabIndex = v ? 0 : -1; });
  }
  function syncFab(want, n) {
    if (want && !dim) buildFab();
    if (fabOpen && (!want || stepAside() || Math.abs((window.pageYOffset || document.documentElement.scrollTop || 0) - fabY) > 24)) setOpen(false);
    if (tagCart) tagCart.querySelector("b").textContent = n > 0 ? "(" + (n > 99 ? "99+" : n) + ")" : "";
    if (want === fabOn) return;
    fabOn = want;
    document.body.classList.toggle("ez-fab-on", want);
    if (want) {
      btn.setAttribute("role", "button");
      btn.setAttribute("aria-expanded", "false");
      btn.setAttribute("aria-label", "Shortcuts: my cart and your gift");
    } else {
      btn.removeAttribute("role");
      btn.removeAttribute("aria-expanded");
      btn.setAttribute("aria-label", "My cart, " + n + (n === 1 ? " item" : " items"));
    }
  }
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") setOpen(false); });
  document.addEventListener("click", function (e) {      /* a tap on Klaviyo's gift: its form opens, this closes */
    if (fabOpen && e.target.closest && e.target.closest("div.needsclick[class*='kl-teaser-']")) setTimeout(function () { setOpen(false); }, 0);
  }, true);

  function sync() {
    frame = 0;
    var n = count();
    /* Ban-29: computers too (before: phones and tablets only) */
    var plain = n > 0 && (window.pageYOffset || document.documentElement.scrollTop || 0) > headerBottom();
    var hub = mq.matches && n > 0 && hasGift();   /* Ban-30/31: the combined button, see section 5 */
    var show = plain || hub;
    if (show && !btn) build();
    if (!btn) return;
    if (n !== last) {
      if (last > 0 && n > last) {
        btn.classList.remove("is-bump");
        void btn.offsetWidth;
        btn.classList.add("is-bump");
      }
      last = n;
      num.textContent = n > 99 ? "99+" : n > 0 ? String(n) : "";
      if (!fabOn) btn.setAttribute("aria-label", "My cart, " + n + (n === 1 ? " item" : " items"));
    }
    if (show !== on) {
      on = show;
      btn.classList.toggle("is-on", show);
      btn.tabIndex = show ? 0 : -1;
      document.body.classList.toggle("ez-cart-on", show);   /* Ban-28: the Klaviyo gift steps up above it */
    }
    syncFab(hub, n);
  }
  function queue() { if (!frame) frame = requestAnimationFrame(sync); }

  /* Ban-121: is a personalised design of this product in the cart? (product pages only; asked again when the cart
     count changes, e.g. after Add to Cart or a removal in the drawer) */
  var pid = (function () {
    var m = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
    return m && m.id ? Number(m.id) : 0;
  })();
  var inCartT = 0, inCartN = -1;
  function checkInCart() {
    inCartT = 0;
    var n = count();
    if (n === inCartN) return;
    inCartN = n;
    if (n <= 0) { document.body.classList.remove("ez-form-incart"); return; }
    var url = ((window.routes && window.routes.cart_url) || "/cart") + ".js";
    fetch(url, { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c || !c.items) return;
        var hit = c.items.some(function (it) {
          return Number(it.product_id) === pid && it.properties && (it.properties._customization_id || it.properties._customization_image);
        });
        document.body.classList.toggle("ez-form-incart", hit);
      })
      .catch(function () {});
  }
  function queueInCart() { if (!pid) return; clearTimeout(inCartT); inCartT = setTimeout(checkInCart, 400); }

  function start() {
    watchMenu();
    window.addEventListener("scroll", queue, { passive: true });
    window.addEventListener("resize", queue);
    if (mq.addEventListener) mq.addEventListener("change", queue);
    var bubbleHost = document.getElementById("cart-icon-bubble");
    if (bubbleHost) new MutationObserver(function () { queue(); queueInCart(); }).observe(bubbleHost, { childList: true, subtree: true, characterData: true });
    queueInCart();
    window.addEventListener("pageshow", queue);
    /* Ban-29: Klaviyo adds (and removes) its gift button on its own schedule; look again every 1.5 s */
    setInterval(queue, 1500);
    sync();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
  /* 4. popups (Ban-26): with a mouse the page scrollbar is no longer hidden while a popup is open (see CSS
     section 4), so a wheel turn over the dark backdrop would scroll the page behind it. Stop that here: inside
     a popup, a list or panel that can still scroll in that direction scrolls as usual; anything else is held. */
  var finePointer = window.matchMedia ? window.matchMedia("(hover: hover) and (pointer: fine)") : null;
  function popupOpen() {
    var b = document.body, h = document.documentElement;
    return b.classList.contains("vm--block-scroll") || h.classList.contains("ezp-ship-open") || b.classList.contains("ez-menu-open") ||   // Ban-83: + phone menu (wheel)
      !!document.querySelector("dialog.ezf-cs__dialog[open], .ezc-pv-open");
  }
  function canScroll(el, dy) {
    for (; el && el !== document.body && el !== document.documentElement; el = el.parentElement) {
      var oy = window.getComputedStyle(el).overflowY;
      if ((oy === "auto" || oy === "scroll") && el.scrollHeight > el.clientHeight + 1) {
        if (dy < 0 ? el.scrollTop > 0 : el.scrollTop + el.clientHeight < el.scrollHeight - 1) return true;
      }
    }
    return false;
  }
  /* Ban-43: listened to only while a popup is open. A wheel listener that may stop scrolling makes the browser wait
     for the page's script before every scroll; while Teeinblue redraws a picture (0.2-0.35 s after each choice) the
     page then stuck. Added when a popup opens, removed when it closes (see syncHold below). */
  function onWheel(e) {
    if (!finePointer || !finePointer.matches || e.ctrlKey || !popupOpen()) return;
    if (!canScroll(e.target, e.deltaY)) e.preventDefault();
  }

  /* Ban-32: the country picker ("Update your preferences") on phones. On iPhone (Safari and Chrome) a drag on it, or
     on the dark area around it, still moved the page behind: opened from the phone menu, the menu was left shifted
     up after closing (header gone, page showing under the menu) and stopped responding. While it is open a drag
     now only scrolls the country list (while the list can still scroll that way); everything behind stays put.
     On close, if the page moved anyway, it goes back to where it was, and the menu takes its measurements again. */
  var csY = null, touchY = 0, touchX = 0;
  function pickerOpen() { return !!document.querySelector("dialog.ezf-cs__dialog[open]"); }
  /* Ban-34: the same hold for "Estimated delivery" and "Photo tips" (ez-personalize.js openSheet): only the page
     (html) is locked behind them now, so on iPhone a drag outside their scrolling part must not reach the page */
  /* Ban-82: and the phone menu. On iPhone a drag on the menu (or past the end of its list) could still move the page
     behind, the header then slid away with the menu under it (the "menu shifted up, page showing" case). While the
     menu is open a drag only scrolls the menu's own list. */
  function holdOpen() {
    return pickerOpen() || document.documentElement.classList.contains("ezp-ship-open") ||
      document.body.classList.contains("ez-menu-open") ||
      document.body.classList.contains("vm--block-scroll") || document.body.classList.contains("teeinblue-block-scroll");   // Ban-135: Teeinblue popups (body no longer locked on phones)
  }
  document.addEventListener("touchstart", function (e) {
    if (e.touches.length === 1) { touchY = e.touches[0].clientY; touchX = e.touches[0].clientX; }
  }, { passive: true, capture: true });
  function onTouchMove(e) {
    if (!e.cancelable || e.touches.length !== 1 || !holdOpen()) return;
    var y = e.touches[0].clientY;
    var dy = touchY - y;                                 // > 0: the content would scroll down
    var dx = e.touches[0].clientX - touchX;
    touchY = y;                                          // the finger may turn back within one drag
    touchX = e.touches[0].clientX;
    if (!dy || Math.abs(dx) > 2 * Math.abs(dy)) return;     // Ban-135: sideways (a picture slider in a popup) is never the page's
    var t = e.target;
    if (t && t.closest && t.closest(".ezf-cs__list, .ezp-ship__body, header-drawer .menu-drawer__inner-container, .vm--container, .ezp-ai") && canScroll(t, dy)) return;   // Ban-82: + menu list; Ban-135: + inside Teeinblue popups
    e.preventDefault();
  }
  /* Ban-43: both holds are on only while a popup is open (the classes below are set when it opens, before any drag
     on it), so swiping and scrolling the product page never wait for this script */
  var holdOn = false;
  function syncHold() {
    var on = popupOpen() || holdOpen();
    if (on === holdOn) return;
    holdOn = on;
    if (on) {
      document.addEventListener("wheel", onWheel, { passive: false });
      document.addEventListener("touchmove", onTouchMove, { passive: false, capture: true });
    } else {
      document.removeEventListener("wheel", onWheel, { passive: false });
      document.removeEventListener("touchmove", onTouchMove, { passive: false, capture: true });
    }
  }
  function watchHold() {
    new MutationObserver(syncHold).observe(document.body, { attributes: true, attributeFilter: ["class"] });
    document.addEventListener("close", syncHold, true);  // the country picker <dialog> closing
    syncHold();
  }
  if (document.body) watchHold(); else document.addEventListener("DOMContentLoaded", watchHold);
  function onPickerOpen() {
    if (csY === null) csY = window.pageYOffset || document.documentElement.scrollTop || 0;
  }
  function onPickerClose() {
    if (csY === null) return;
    var y = csY;
    csY = null;
    var fix = function () {
      if (Math.abs((window.pageYOffset || 0) - y) > 1) window.scrollTo(0, y);
      var menu = document.querySelector("header-drawer details[open]");
      var header = document.querySelector(".section-header");
      if (menu && header) {
        var root = document.documentElement.style;
        root.setProperty("--viewport-height", window.innerHeight + "px");
        root.setProperty("--header-bottom-position", Math.max(0, parseInt(header.getBoundingClientRect().bottom - (header.querySelector(".header-wrapper--border-bottom") ? 1 : 0), 10)) + "px");
      }
    };
    fix();
    setTimeout(fix, 120);                                 // iPhone settles its toolbar a moment later
  }
  new MutationObserver(function () {
    if (document.documentElement.classList.contains("ezf-cs-lock")) onPickerOpen();
    else onPickerClose();
    syncHold();
  }).observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });
})();
